import React, { useState } from "react";
import { VscEye, VscEyeClosed } from "react-icons/vsc";
import { changePassword, useUser } from "../../redux/services/authSlice";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const ChangePassword = () => {
  const [toggle0, setToggle0] = useState(false);
  const [toggle1, setToggle1] = useState(false);
  const [toggle2, setToggle2] = useState(false);
  const [resetLoading, setResetLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useUser();
  const initialValues = {
    userId: user._id,
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  };

  const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]).{8,}$/;

  const validationSchema = Yup.object({
    oldPassword: Yup.string().required("Old password is required"),
    newPassword: Yup.string()
      .matches(
        passwordRegex,
        "Password must include uppercase, lowercase, number, and special character."
      )
      .min(8, "Password must be at least 8 characters long")
      .required("New password is required"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
      .required("Confirm password is required"),
  });

  const onSubmit = async (values) => {
    let payload = {
      userId: values.userId,
      oldPassword: values?.oldPassword,
      newPassword: values?.newPassword,
    };
    setResetLoading(true);
    try {
      let response = await dispatch(changePassword(payload));
      if (response?.payload?.status === 200) {
        resetForm();
        navigate("/");
        toast(response?.payload?.message, {
          autoClose: 2000,
          pauseOnHover: false,
        });
      } 
    } catch (error) {
    } finally {
      setResetLoading(false);
    }
  };

  const {
    handleChange,
    handleBlur,
    values,
    errors,
    touched,
    handleSubmit,
    resetForm,
  } = useFormik({
    initialValues,
    validationSchema,
    onSubmit,
  });

  return (
    <div className="flex items-center justify-center min-h-full bg-[#124699]">
    <div className="bg-white p-8 rounded-md shadow-md w-full max-w-lg mx-3">
      <h2 className="text-xl font-bold text-[#405189] text-center mb-1">
        Change Password
      </h2>
      <p className="text-center text-gray-500 mb-4">
        Change your password to secure your account
      </p>
      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label className="block text-sm font-medium mb-1">Old Password</label>
          <div className="relative">
            <input
              type={toggle0 ? "text" : "password"}
              name="oldPassword"
              value={values.oldPassword}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder="Enter old password"
              className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
            />
            <button
              type="button"
              onClick={() => setToggle0(!toggle0)}
              className="absolute inset-y-0 end-0 flex items-center z-20 px-3 cursor-pointer text-gray-400"
            >
              {toggle0 ? <VscEyeClosed title="Show Password" /> : <VscEye title="Hide Password" />}
            </button>
          </div>
          {errors.oldPassword && touched.oldPassword && (
            <p className="mt-1 px-2 text-red-600 text-sm">{errors.oldPassword}</p>
          )}
        </div>
  
        <div className="mb-4">
          <label className="block text-sm font-medium mb-1">New Password</label>
          <div className="relative">
            <input
              type={toggle1 ? "text" : "password"}
              name="newPassword"
              value={values.newPassword}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder="Enter new password"
              className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
            />
            <button
              type="button"
              onClick={() => setToggle1(!toggle1)}
              className="absolute inset-y-0 end-0 flex items-center z-20 px-3 cursor-pointer text-gray-400"
            >
              {toggle1 ? <VscEyeClosed title="Show Password" /> : <VscEye title="Hide Password" />}
            </button>
          </div>
          {errors.newPassword && touched.newPassword && (
            <p className="mt-1 px-2 text-red-600 text-sm">{errors.newPassword}</p>
          )}
        </div>
  
        <div className="mb-4">
          <label className="block text-sm font-medium mb-1">Confirm New Password</label>
          <div className="relative">
            <input
              type={toggle2 ? "text" : "password"}
              name="confirmPassword"
              value={values.confirmPassword}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder="Confirm new password"
              className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
            />
            <button
              type="button"
              onClick={() => setToggle2(!toggle2)}
              className="absolute inset-y-0 end-0 flex items-center z-20 px-3 cursor-pointer text-gray-400"
            >
              {toggle2 ? <VscEyeClosed title="Show Password" /> : <VscEye title="Hide Password" />}
            </button>
          </div>
          {errors.confirmPassword && touched.confirmPassword && (
            <p className="mt-1 px-2 text-red-600 text-sm">{errors.confirmPassword}</p>
          )}
        </div>
  
        <button
          type="submit"
          className="w-full bg-[#F48224] mt-7 text-white py-2 rounded-md hover:bg-[#e0731a] transition flex justify-center"
        >
          {resetLoading ? <div className="loader"></div> : "Reset Password"}
        </button>
      </form>
    </div>
  </div>
  
  );
};

export default ChangePassword;
